import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "ml-1" }
const _hoisted_3 = { class: "ml-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-excel-o" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  filter: "createdOn",
  filterType: "dateRange",
  filterFrom: "fromDate",
  filterTo: "toDate",
  sort: "createdOn"
}
const _hoisted_7 = {
  filter: "cliente",
  sort: "nomeCliente"
}
const _hoisted_8 = {
  filter: "reteCommercialeParent",
  sort: "reteCommercialeParent.name"
}
const _hoisted_9 = {
  filter: "telefono.completeNumber",
  sort: "telefono.completeNumber"
}
const _hoisted_10 = {
  filter: "importo",
  sort: "importo"
}
const _hoisted_11 = {
  filter: "Spedizione",
  sort: "speseSpedizione"
}
const _hoisted_12 = {
  filter: "offers",
  sort: "offers"
}
const _hoisted_13 = {
  filter: "nomeProdotto",
  sort: "nomeProdotto"
}
const _hoisted_14 = {
  filter: "tipoPagamento",
  sort: "tipoPagamento"
}
const _hoisted_15 = {
  filter: "points",
  sort: "points"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { colspan: "99" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["href"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { key: 0 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_toggler = _resolveComponent("toggler")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h4", null, [
      _createVNode(_component_localized_text, {
        localizedKey: "Vendite",
        text: "Vendite"
      })
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_toggler, {
        modelValue: _ctx.filter.showPrenotazioni,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter.showPrenotazioni) = $event))
      }, null, 8, ["modelValue"]),
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_localized_text, {
          localizedKey: "Mosta Prenotazioni",
          text: "Mosta Prenotazioni"
        })
      ]),
      _createVNode(_component_toggler, {
        class: "ml-2",
        modelValue: _ctx.filter.showAssegnazioni,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter.showAssegnazioni) = $event))
      }, null, 8, ["modelValue"]),
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Mosta Assegnazioni",
          text: "Mosta Assegnazioni"
        })
      ])
    ]),
    (_ctx.$store.state.isAdmin())
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "btn btn-primary pull-right ml-2",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.exportExcel && _ctx.exportExcel(...args)))
        }, _hoisted_5))
      : _createCommentVNode("", true),
    _createVNode(_component_op_table, {
      class: "table table-striped",
      itemsPerPage: _ctx.filter.perPage,
      items: _ctx.tableResult.data,
      filter: _ctx.filter,
      totalItemsCount: _ctx.tableResult.count,
      onSearch: _ctx.search
    }, {
      default: _withCtx((opData) => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_6, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data",
                text: "Data"
              })
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createVNode(_component_localized_text, {
                localizedKey: "Cliente",
                text: "Cliente"
              })
            ]),
            _createElementVNode("td", _hoisted_8, [
              _createVNode(_component_localized_text, {
                localizedKey: "Commerciale",
                text: "Commerciale"
              })
            ]),
            _createElementVNode("td", _hoisted_9, [
              _createVNode(_component_localized_text, {
                localizedKey: "Telefono",
                text: "Telefono"
              })
            ]),
            _createElementVNode("td", _hoisted_10, [
              _createVNode(_component_localized_text, {
                localizedKey: "Importo",
                text: "Importo"
              })
            ]),
            _createElementVNode("td", _hoisted_11, [
              _createVNode(_component_localized_text, {
                localizedKey: "Spese spedizione",
                text: "Spese spedizione"
              })
            ]),
            _createElementVNode("td", _hoisted_12, [
              _createVNode(_component_localized_text, {
                localizedKey: "Carrello",
                text: "Carrello"
              })
            ]),
            _createElementVNode("td", _hoisted_13, [
              _createVNode(_component_localized_text, {
                localizedKey: "Prodotto",
                text: "Prodotto"
              })
            ]),
            _createElementVNode("td", _hoisted_14, [
              _createVNode(_component_localized_text, {
                localizedKey: "Tipo pagamento",
                text: "Tipo pagamento"
              })
            ]),
            _createElementVNode("td", _hoisted_15, [
              _createVNode(_component_localized_text, {
                localizedKey: "Punti",
                text: "Punti"
              })
            ]),
            (_ctx.$store.state.isAdmin())
              ? (_openBlock(), _createElementBlock("td", _hoisted_16))
              : _createCommentVNode("", true),
            _hoisted_17
          ])
        ]),
        _createElementVNode("tbody", null, [
          (opData.items.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                _createElementVNode("td", _hoisted_19, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nessun elemento trovato",
                    text: "Nessun elemento trovato"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.items as OM.AcquistoTableVm[]), (item) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: item.identifier,
              onClick: ($event: any) => (_ctx.selectedRow = item.identifier),
              class: _normalizeClass({ selectedRow: _ctx.selectedRow == item.identifier })
            }, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.createdOn, "YYYY-MM-DD HH:mm")), 1),
              _createElementVNode("td", null, [
                _createElementVNode("a", {
                  href: '#/clienti/detail/' + item.clienteIdentifier
                }, _toDisplayString(item.nomeCliente), 9, _hoisted_21)
              ]),
              _createElementVNode("td", null, _toDisplayString(item.reteCommercialeParent.name), 1),
              _createElementVNode("td", null, _toDisplayString(item.telefono && item.telefono.completeNumber), 1),
              _createElementVNode("td", null, _toDisplayString(item.importo), 1),
              _createElementVNode("td", null, _toDisplayString(item.speseSpedizione), 1),
              _createElementVNode("td", null, [
                (item.offers.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-link",
                        onClick: ($event: any) => (_ctx.openOffersModal(item.offers))
                      }, [
                        _createElementVNode("u", null, [
                          _createTextVNode(_toDisplayString(item.offers.length) + " ", 1),
                          _createVNode(_component_localized_text, {
                            localizedKey: "elementi",
                            text: "elementi"
                          })
                        ])
                      ], 8, _hoisted_23),
                      _hoisted_24,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.offers, (offer, i) => {
                        return (_openBlock(), _createElementBlock("div", { key: i }, [
                          _createElementVNode("small", null, "- " + _toDisplayString(offer.name), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", null, _toDisplayString(item.nomeProdotto), 1),
              _createElementVNode("td", null, _toDisplayString(item.tipoPagamento), 1),
              _createElementVNode("td", null, _toDisplayString(item.points), 1),
              (_ctx.$store.state.isAdmin())
                ? (_openBlock(), _createElementBlock("td", _hoisted_25, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-danger",
                      onClick: ($event: any) => (_ctx.remove(item))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Elimina",
                        text: "Elimina"
                      })
                    ], 8, _hoisted_26)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("td", null, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-primary",
                  onClick: ($event: any) => (_ctx.ricevuta(item))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Ricevuta",
                    text: "Ricevuta"
                  })
                ], 8, _hoisted_27)
              ])
            ], 10, _hoisted_20))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["itemsPerPage", "items", "filter", "totalItemsCount", "onSearch"])
  ]))
}